import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ContratosEntity, ContratistaEntity, ContratosExcel, BuscaContratista } from "../entities/contratistas_entity";
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { UtilService } from '../../../components/common/utils/util.service';
import { ContratoSegurosService } from './contrato-seguros.service';
import { ContratoSegurosEntity } from '../entities/contrato_seguros_entity';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'contratoSeguros',
    templateUrl: 'contrato-seguros.template.html'
})

export class ContratoSegurosComponent implements OnInit {
    showLoader: string;
    usuarioEmpresa: ClienteXCiudad;
    listaContratos: ContratoSegurosEntity[];
    listaClientes: string[];
    listaObjetoContrato: string[];
    listaNumContrato: string[];
    listaNumContratoInterno: string[];
    clienteSeleccionado: string;
    objContratoSeleccionado: string;
    numContratoSeleccionado: string;
    numContratoInternoSeleccionado: string;
    listaContratosMostrar: ContratoSegurosEntity[];
    contratoDetalle: ContratoSegurosEntity;
    @ViewChild('detalleContrato')
    modal: ModalComponent;
    

    constructor(
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public contratoSegurosService: ContratoSegurosService
    ) {
       this.usuarioEmpresa = new ClienteXCiudad();
       this.listaContratos = new Array<ContratoSegurosEntity>();
       this.listaClientes = new Array<string>();
       this.listaObjetoContrato = new Array<string>();
       this.listaNumContrato = new Array<string>();
       this.listaNumContratoInterno = new Array<string>();
       this.clienteSeleccionado = "";
       this.objContratoSeleccionado = "";
       this.numContratoInternoSeleccionado = "";
       this.numContratoSeleccionado = "";
       this.listaContratosMostrar = new Array<ContratoSegurosEntity>();
       this.contratoDetalle = new ContratoSegurosEntity()
    }
    ngOnInit(): void {
        this.showLoader = "sk-loading";
        try{
            this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        }catch(e){
            this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioempresa");
        }
        this.contratoSegurosService.consultarListContratos(this.usuarioEmpresa).subscribe(
            result =>{
                this.listaContratos = result;
                let nombres = this.listaContratos.map(function(a){ return a.CTR_NOM.trim();});
                this.listaClientes = nombres.filter(function(v,i){ return nombres.indexOf(v.trim()) == i});
                this.showLoader = "";
            },
            error=>{
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
    cambioCliente(e: string){
        this.clienteSeleccionado = e;
        let filtro =  this.listaContratos.filter(function(a){ 
            if(a.CTR_NOM.trim() == e.trim()){
                return a;
            }
        });
        let objectoContrato = filtro.map(function(a){ return a.CON_DES.trim()});
        this.listaObjetoContrato = objectoContrato.filter(function(v,i){ return objectoContrato.indexOf(v.trim()) == i});
    }
    cambioObjetoContrato(e: string){
        this.objContratoSeleccionado = e;
        let filtro = this.listaContratos.filter((function(a){
            if(a.CTR_NOM.trim() == this.clienteSeleccionado && a.CON_DES.trim() == e.trim()){
                return a;
            }
        }).bind(this));
        let numContrato = filtro.map(function(a: ContratoSegurosEntity){ return a.CON_NUM.trim()});
        this.listaNumContrato = numContrato.filter(function(v,i){ return numContrato.indexOf(v.trim()) == i});
    }
    cambioNumContrato(e: string){
        this.numContratoSeleccionado = e;
        let filtro = this.listaContratos.filter((function(a){
            if(a.CTR_NOM.trim() == this.clienteSeleccionado && a.CON_DES.trim() == this.objContratoSeleccionado.trim() && a.CON_NUM == e){
                return a;
            }
        }).bind(this));
        let numContratoInterno = filtro.map(function(a: ContratoSegurosEntity){ return a.CON_NUM_INT.trim()});
        this.listaNumContratoInterno = numContratoInterno.filter(function(v,i){ return numContratoInterno.indexOf(v.trim()) == i});
    }
    cambioNumContratoInterno(e: string){
        this.numContratoInternoSeleccionado = e;
        this.listaContratosMostrar = this.listaContratos.filter((function(a: ContratoSegurosEntity){
            if(a.CON_NUM_INT == e && a.CTR_NOM.trim() == this.clienteSeleccionado && a.CON_DES.trim() == this.objContratoSeleccionado.trim() && a.CON_NUM == this.numContratoSeleccionado){
                return a;
            }
        }).bind(this));
    }
    abrirDetalle(contrato: ContratoSegurosEntity){
        this.modal.open();
        this.contratoDetalle = contrato;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/contratoSeguros/contrato-seguros.component.ts